export default "__VITE_ASSET__DEzMQxoL__"